var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlugtskydningsbane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#427c7f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.469,6.44l.856-.465a.388.388,0,0,0,.047.159.408.408,0,0,0,.359.213A.414.414,0,0,0,7.925,6.3L9.961,5.191a.4.4,0,0,0,.057-.678l1.893-1.029a.407.407,0,1,0-.389-.716L4.565,6.546c-.013.007-.021.02-.034.028s-.025,0-.037.01L1.955,7.963a.409.409,0,0,0-.164.553l.671,1.235a.406.406,0,0,0,.277.205.445.445,0,0,0,.081.008.414.414,0,0,0,.254-.088L4.637,8.638l.518.04a.407.407,0,0,0,.426-.305l.242-.934.59-.32a.408.408,0,0,0,.163-.553A.386.386,0,0,0,6.469,6.44Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,9.294h-.047a2.48,2.48,0,0,0-2.039-2.038V7.143a.408.408,0,1,0-.815,0v.113A2.48,2.48,0,0,0,7.559,9.294H7.4a.408.408,0,1,0,0,.815h.158A2.482,2.482,0,0,0,9.6,12.148v.132a.408.408,0,0,0,.815,0v-.132a2.482,2.482,0,0,0,2.039-2.039H12.5a.408.408,0,1,0,0-.815Zm-2.087,2.023a.407.407,0,0,0-.814,0A1.667,1.667,0,0,1,8.388,10.1a.4.4,0,0,0,0-.8A1.67,1.67,0,0,1,9.6,8.086V8.1a.408.408,0,1,0,.815,0V8.086a1.67,1.67,0,0,1,1.209,1.208h-.082a.408.408,0,1,0,0,.815h.082A1.668,1.668,0,0,1,10.411,11.317Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.005,
    cy: 9.702,
    r: 0.405,
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlugtskydningsbane);
export default __webpack_public_path__ + "static/media/FLUGTSKYDNINGSBANE.69fe9de7c1a673c0cedd32ca7e9cb490.svg";
export { ForwardRef as ReactComponent };